import React from 'react';

export default function About() {
    return (
        <section id="about" className="max-w-6xl px-4 py-2">
            <div className="bg-black/90 rounded-xl border border-red-400/30 shadow-lg shadow-black/40 px-6 py-5">
                <h2 className="text-4xl font-bold text-white tracking-tight pl-2">About Me</h2>
                <hr className="mt-2 border-t-2 border-red-400 w-[11.5rem]"/>
                <p className="text-gray-400 text-base italic mt-3">Get to know me a bit. Game development is what fuels my soul.</p>

                <div className="bg-gray-800/20 border border-red-400/20 rounded-lg px-5 py-5 mt-6">
                    <div className="text-gray-200 text-lg leading-relaxed space-y-4">
                        <p>
                            I've been building games since I was 13 years old, figuring it all out on Roblox Studio.
                            Since graduating High School and finishing what I set out to do in college, I'm working
                            on projects with <span className="font-bold text-red-500"><a href="https://glumpis.itch.io/" target="_blank" rel="noopener noreferrer">Glumpis Games</a></span>.
                        </p>
                        <p>
                            <span className="font-bold text-red-500"><a href="https://glumpis.itch.io/" target="_blank" rel="noopener noreferrer">Glumpis Games</a></span> is a company I've co-founded with my best friend of almost 10 years,
                            Whitman Wilson. Together, we make fun little Game Jam games, and work on our
                            long-term project that has yet to be announced.
                        </p>
                        <p>
                            Most of what I do includes: <span className="font-bold">Level design, UI design and programming, Gameplay
                            programming, and 3D modelling</span>.
                        </p>
                        <p>
                            I am constantly working and trying to grow what I love into
                            a career, so stay tuned for more projects!
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}